import React from "react";

const NavigationButton = ({ text, icon, ...props }) => {
  return (
    <button
      className="flex items-center space-x-2 justify-center min-w-[124px] navigation-button"
      {...props}
    >
      {icon && icon}
      <p className="text-sm font-medium ">{text}</p>
    </button>
  );
};

export default NavigationButton;
